import { formatBenefitValue } from "./helper";

function transformCoverageOptions(coverage, allowedBenefits = null) {
    if (allowedBenefits && !allowedBenefits.includes(coverage.code)) return [];

    const isNoCoverageOption = (code) => /(_no|_na)$/.test(code);

    return coverage.options.map(option => ({
        codeFactorOption: option.code,
        description: formatBenefitValue(option.description, option.type),
        factor: option.code,
        "factorId.factorTypeId.codeFactor": coverage.code,
        "factorId.factorTypeId.description": coverage.description,
        "factorId.id": coverage.code,
        "factorId.nameFactor": coverage.description,
        "factorId.portalType": coverage.code,
        id: option.code,
        isNoCoverageOption: isNoCoverageOption(option.code),
        version: 1
    }));
}


export function transformData(inputData, typeBenefit = '') {
    const allowedBenefits = {
        structural: ['maxcovpipoly', 'geogrcov', 'provdnet', 'dednonusa', 'dedusa', 'coinsurance', 'maxcoinoop'],
        regular: ['congenit', 'hazardsp', 'deathcov', 'inmental', 'orgtrans', 'mxoutcov', 'compther', 'deductbl', 'healthch', 'matrnity', 'eyesurgr', 'barsurgr']
    };

    const transformedData = inputData.benefits.flatMap(coverage =>
        transformCoverageOptions(coverage, allowedBenefits[typeBenefit])
    );

    return {
        status: 0,
        offset: 0,
        total: transformedData.length,
        data: transformedData
    };
}

export function transformOptions(benefit) {
    const transformedData = transformCoverageOptions(benefit.getBenefitByCode);

    return {
        status: 0,
        offset: 0,
        total: transformedData.length,
        data: transformedData
    };
}
